(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/skeleton/result-sportkryss-fallback.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/skeleton/result-sportkryss-fallback.js');
"use strict";

const {
  CenterToScreen
} = svs.components.tipsen.centerToScreen;
const {
  SkeletonLine,
  SkeletonCircle
} = svs.components.lbUi;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const ResultSportkryssFallback = () => {
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_SM));
  const lgCircleSize = isWideScreen ? 40 : 20;
  return React.createElement(CenterToScreen, null, React.createElement("div", {
    className: "skeleton-sportkryss-container skeleton-sportkryss-container-first-item"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  }), React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  }), React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  }), React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  }), React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  }), React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  }), React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-circle-lg",
    size: lgCircleSize
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement("div", {
    className: "skeleton-sportkryss-title"
  }, "Antal r\xE4tt"), React.createElement("div", {
    className: "skeleton-sportkryss-title"
  }, "Vinnare"), React.createElement("div", {
    className: "skeleton-sportkryss-title"
  }, "Utdelning")), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-cicle",
    size: 25
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss skeleton-sportkryss-middle"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-cicle",
    size: 25
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss skeleton-sportkryss-middle"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-cicle",
    size: 25
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss skeleton-sportkryss-middle"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-cicle",
    size: 25
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss skeleton-sportkryss-middle"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-cicle",
    size: 25
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss skeleton-sportkryss-middle"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container"
  }, React.createElement(SkeletonCircle, {
    className: "skeleton-sportkryss-cicle",
    size: 25
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss skeleton-sportkryss-middle"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })), React.createElement("div", {
    className: "skeleton-sportkryss-container skeleton-sportkryss-container-last-item"
  }, React.createElement("p", {
    className: "skeleton-sportkryss-title"
  }, "Oms\xE4ttning: "), React.createElement(SkeletonLine, {
    className: "skeleton-sportkryss"
  })));
};
setGlobal('svs.components.tipsen.routeResult.ResultSportkryssFallback', ResultSportkryssFallback);

 })(window);